/**
 * Mobile Swipe Gallery für Outdoorheld Custom Gallery
 * Arbeitet mit .media-gallery Struktur
 */
document.addEventListener('DOMContentLoaded', function() {
  initCustomGallerySwipe();
});

function initCustomGallerySwipe() {
  const galleryMain = document.querySelector('.media-gallery__main');
  if (!galleryMain) return;

  const viewport = galleryMain.querySelector('.media-gallery__viewport');
  const items = galleryMain.querySelectorAll('.media-gallery__item');
  
  if (items.length < 2) return;

  let currentIndex = 0;
  let startX = 0;
  let currentX = 0;
  let isDragging = false;
  const threshold = 50; // Mindestens 50px zum Swipen

  // Touch Events
  viewport.addEventListener('touchstart', handleTouchStart, false);
  viewport.addEventListener('touchmove', handleTouchMove, false);
  viewport.addEventListener('touchend', handleTouchEnd, false);

  function handleTouchStart(e) {
    isDragging = true;
    startX = e.touches[0].clientX;
    currentX = startX;
  }

  function handleTouchMove(e) {
    if (!isDragging) return;
    currentX = e.touches[0].clientX;
  }

  function handleTouchEnd(e) {
    if (!isDragging) return;
    isDragging = false;

    const diff = startX - currentX;

    // Swipe nach links (nächstes Bild)
    if (diff > threshold && currentIndex < items.length - 1) {
      currentIndex++;
      updateActiveItem(currentIndex);
    }
    // Swipe nach rechts (vorheriges Bild)
    else if (diff < -threshold && currentIndex > 0) {
      currentIndex--;
      updateActiveItem(currentIndex);
    }
  }

  function updateActiveItem(index) {
    // Entferne --active Klasse von allen Items
    items.forEach(item => item.classList.remove('media-gallery__item--active'));
    
    // Setze --active Klasse für neues Item
    items[index].classList.add('media-gallery__item--active');

    // Scroll Thumbnails (falls vorhanden)
    const thumbnails = document.querySelectorAll('.media-gallery__thumbnail');
    if (thumbnails.length > 0) {
      // Entferne --active von Thumbnails
      thumbnails.forEach(thumb => thumb.classList.remove('media-gallery__thumbnail--active'));
      
      // Setze --active für aktuellen Thumbnail
      if (thumbnails[index]) {
        thumbnails[index].classList.add('media-gallery__thumbnail--active');
        
        // Scroll zu Thumbnail
        const thumbnailsContainer = document.querySelector('.media-gallery__thumbnails');
        if (thumbnailsContainer) {
          const thumbOffset = thumbnails[index].offsetLeft - thumbnailsContainer.offsetLeft;
          const containerWidth = thumbnailsContainer.offsetWidth;
          const thumbWidth = thumbnails[index].offsetWidth;
          
          thumbnailsContainer.scrollLeft = thumbOffset - (containerWidth - thumbWidth) / 2;
        }
      }
    }
  }

  // Optional: Keyboard Navigation (Pfeiltasten)
  document.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft' && currentIndex > 0) {
      currentIndex--;
      updateActiveItem(currentIndex);
    } else if (e.key === 'ArrowRight' && currentIndex < items.length - 1) {
      currentIndex++;
      updateActiveItem(currentIndex);
    }
  });

  // Optional: Click auf Thumbnails auch für Index-Tracking
  const thumbnails = document.querySelectorAll('.media-gallery__thumbnail');
  thumbnails.forEach((thumb, index) => {
    thumb.addEventListener('click', () => {
      currentIndex = index;
    });
  });
}
